import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const CalendarioConfigCivilService = {
  async putParametrizarCalendario(postData) {
    postData.append("_method", "PUT");
    const response = await BaseService.fetchResponseFromAPIPost(
      "civil/parametrizarcalendario/5",
      postData,
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    SnackBarModule("Calendário atualizado com sucesso.", "success");
    return true;
  },

  async getParametrizarCalendario() {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/parametrizarcalendario/buscar/5`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },
}